import { biLoggerFactory } from 'wix-private';
const msid = 'd88335f3-bb20-4d96-999f-0f7c0ebc6720'; //replace the value between quotes with your site msid value
/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */
const ctabBIGroupsLoggers = {
    19: biLoggerFactory('lp', 19, { msid }),
}
export async function fireCTABIEvent(src, evid, fields) {
    const biLogger = ctabBIGroupsLoggers[src];

    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired, fields: ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}


const scrollBIGroupsLoggers = {
    19: biLoggerFactory('fb-ads-lp', 19, { msid }),
}

export async function fireScrollEvent(src, evid, fields) {
    const biLogger = scrollBIGroupsLoggers[src];

    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired, fields: ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}